import { Column, Entity } from 'typeorm'
import { BaseEntity } from '../entity'

@Entity()
export class UserCredentials extends BaseEntity<UserCredentials> {
	@Column({
		type: 'text',
		nullable: false,
	})
	password: string
}
